import { Injectable } from '@angular/core';
import { NavItemInterface } from '@app/_interfaces';
import { State, Action, Selector, StateContext, Select } from '@ngxs/store';
import { SetSettingsNav, SettingsExecuteSubmit, TranslateSite } from './settings.actions';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from '@app/core/store/app.state';
import { catchError, Observable, tap } from 'rxjs';
import { PagesService } from '@app/_services/pages/pages.service';
import { ResponseHelper } from '@app/_shared/helpers/ResponseHelper';
import { McToastService } from '@app/_services';

export interface SettingsStateModel {
    nav: NavItemInterface[];
    settingsExecuteSubmit: boolean;
}

@State<SettingsStateModel>({
    name: 'settings',
    defaults: {
        nav: [],
        settingsExecuteSubmit: false,
    },
})
@Injectable()
export class SettingsState {
    @Select(AppState.getMarketLanguageValue)
    initialLanguage: Observable<string>;

    constructor(
        private pageService: PagesService,
        private responseHelper: ResponseHelper,
        private mcToast: McToastService,
        private translate: TranslateService
    ) {}

    @Selector()
    public static getState(state: SettingsStateModel) {
        return state;
    }

    @Selector()
    public static nav(state: SettingsStateModel) {
        return state.nav;
    }

    @Selector()
    public static settingsExecuteSubmit(state: SettingsStateModel) {
        return state.settingsExecuteSubmit;
    }

    @Action(SetSettingsNav)
    public setNav({ patchState }: StateContext<SettingsStateModel>, { isOwnwer }: SetSettingsNav) {
        return patchState({
            nav: [
                {
                    label: this.translate.instant('app.nav.page_languages'),
                    link: 'page-languages',
                    icon: 'id-card',
                    show: true,
                },
                {
                    label: this.translate.instant('app.nav.market_reset'),
                    link: 'restart-wizard',
                    icon: 'align-left',
                    show: isOwnwer,
                },
            ],
        });
    }

    @Action(SettingsExecuteSubmit)
    public settingsExecuteSubmit(
        { patchState, getState }: StateContext<SettingsStateModel>,
        { execute }: SettingsExecuteSubmit
    ) {
        patchState({
            settingsExecuteSubmit: execute,
        });
    }

    @Action(TranslateSite)
    public TranslateSite({ getState, patchState }: StateContext<SettingsStateModel>, { payload }: TranslateSite) {
        return this.pageService.translateSite(payload).pipe(
            tap((res) => {
                if (res) {
                    const checkResponse = this.responseHelper.checkError(res);
                    if (checkResponse.success) {
                        this.mcToast.success(this.translate.instant('app.ajustes.idiomas.modal.translate_site_success'));
                    }
                }
            }),
            catchError((err) => {
                this.mcToast.danger(this.translate.instant('app.ajustes.idiomas.modal.translate_site_error'));
                return err;
            })
        );
    }
}
